module.exports = __webpack_public_path__ + "img/logo11.dccf388a.png";